import { DriverDetails2, MtaChangeType } from '../../services/api';
import { IMidTermAdjustmentState } from '../../store/midTermAdjustment.slice';
import mtaHandleRating from '../mta-handle-rating';
import { Product } from '@acorn-portal/shared/src/services/interface/Shared';

const handleManageDrivers = async ({
	midTermAdjustment,
	values,
	product,
}: {
	midTermAdjustment: IMidTermAdjustmentState;
	values: DriverDetails2[];
	product: Product;
}) => {
	const command = {
		changeType: [...midTermAdjustment.changeType, MtaChangeType.CHANGE_DRIVER],
		mtaStartDate: midTermAdjustment.mtaStartDate,
		policyToken: midTermAdjustment.policyToken,
		midTermAdjustment: {
			...midTermAdjustment,
			drivers: values,
		},
	};
	try {
		const ratingResponse = await mtaHandleRating(product, command);
		return ratingResponse;
	} catch (error) {
		console.error('Error in handleManageDrivers:', error);
		throw error;
	}
};

export default handleManageDrivers;
